import { requireBoundCell } from './global/cell-store';
import { isGlobalSurface } from './surface-mode';

export function getAgentosUrl(): string {
  if (isGlobalSurface()) return requireBoundCell().origins.agentos;
  return import.meta.env.VITE_AGENTOS_URL || 'http://localhost:7777';
}
